import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import Form from 'view/templates/base-form';
import Picture from '../components/picture';
import { TEXTS } from '../constants';

const SuccessUploadForm = ({ context }) => {
  const { driver } = context;
  const { TITLE, SUBTITLE } = TEXTS.SUCCESS;

  return (
    <Form>
      <Form.Header title={TITLE} subtitle={SUBTITLE} />

      <Box
        data-testid="success-form"
        pb={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Picture picture={driver.profilePicture} />
      </Box>
    </Form>
  );
};

SuccessUploadForm.propTypes = {
  context: PropTypes.shape({
    driver: PropTypes.shape({
      profilePicture: PropTypes.string
    })
  }).isRequired
};

export default SuccessUploadForm;
